// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const TOAST_ERRORS_IN_FORM = "Formul\u00e1r sa nepodarilo odosla\u0165. Niekde v \u0148om m\u00e1\u0161 chybu.";
